import React, { useState, useEffect } from "react";
import { Badge, Button, Card, Col, Container, ListGroup, Modal, Row } from "react-bootstrap";
import Confirm from "./Confirm";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import inventoryApi from "../api/inventoryApi";
import FilesCreate from "./FilesCreate";
import RelatedListFiles from "./RelatedListFiles";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import moment from 'moment';
import Form from "react-bootstrap/Form";
import Alert from 'react-bootstrap/Alert';
import pdfMake from "pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import CaseHistory from "./CaseHistory";
import * as constants from "../constants/CONSTANT";
import FacpSectionResult from "./FacpSectionResult";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import WorkerBehaviour from "./WorkerBehaviour";
import Nav from 'react-bootstrap/Nav';
import StudentBehaviourPdf from "./StudentBehaviourPdf";




const StudentView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [student, setStudent] = useState(location.state ? location.state : {});
  //console.log('student view location', student)

  let Sid = student;
  const [modalShow, setModalShow] = useState(false);
  const [studentmodalShow, setStudentModalShow] = useState(false);

  const [modalShowTaskfile, setModalShowFile] = useState(false);
  const [refreshFileList, setRefreshFileList] = useState();
  const [age, setAge] = useState();
  const [registrationAge, setRegistrationAge] = useState();

  const [showDetails, setshowDetails] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [facpAssessment, setFacpAssessment] = useState([]);
  const [facpAssessmentpdf, setFacpAssessmentPdf] = useState([]);

  const [assessmentId, setAssessmentId] = useState('');
  const [diffrenceAge, setDiffrenceAge] = useState();
  const [facpModalShow, setfacpModalShow] = useState(false);
  const [pdfInfoFacp, setpdfInfoFacp] = useState({});
  const [nextButtontrue, setNextButtonTrue] = useState(false);
  const [dataFacp, setDataFacp] = useState([]);
  const [generateFacpReport, setgenerateFacpReport] = useState(false);
  const [assessmentResult, setAssessmentResult] = useState([]);
  const [showfacpPdfComponent, setshowfacpPdfComponent] = useState(false);
  const [currentAssessmentType, setcurrentAssessmentType] = useState();
  const [phsyioShowModal, setphsyioShowModal] = useState(false);
  const [physioResult, setphysioResult] = useState([]);
  const [physioAssessmentId, setphysioAssessmentId] = useState();
  const [phsioQuestionMarks, setphsioQuestionMarks] = useState([]);
  const [requiredDocuments, setrequiredDocuments] = useState({});
  const [showWorkBehaviour, setshowWorkBehaviour] = useState(false);
  const [ShowselectYear, setShowSelectYear] = useState(false);
  const [totalStudent, setTotalStudent] = useState({});
  /**
   * RMKM new Implementation
   * @addedBy @ali-hussain
   * date : 12 September 2025
   * Added new state for assessment number
   *  */
  const [assessmentNumberList, setAssessmentNumberList] = useState([]);
  const [showAssessmentSelection, setShowAssessmentSelection] = useState(false);
  const [assessmentNumber, setAssessmentNumber] = useState(null);
  const [scoringName, setScoringName] = useState('');
  useEffect(() => {
    fetchStudentById();
    ////console.log(localStorage.getItem("permissions"));
    sumOfStudent();
  }, []);

  const sumOfStudent = async () => {
    let result = await inventoryApi.fetchSumOfStudents(student.id);
    console.log("result of Student>>", result);
    if (result != null) {
      setTotalStudent(result);
    }
    else {
      setTotalStudent({});
    }


  }





  let ageData = 0
  useEffect(() => {
    (async () => {

      let age = null;
      const dob = moment(student.dob);
      const today = moment();

      const yearsDiff = today.year() - dob.year();
      dob.add(yearsDiff, 'years');
      const monthsDiff = today.month() - dob.month();
      let ageInFloat = yearsDiff + (monthsDiff / 12);
      ageInFloat = parseFloat(ageInFloat.toFixed(1));
      //console.log('dob age', ageInFloat);

      let registrationAge = null;
      const registrationDate = moment(student.childregistrationdate);
      const todayDate = moment();

      const yearsDifference = todayDate.year() - registrationDate.year();
      dob.add(yearsDifference, 'years');
      const monthsDifference = todayDate.month() - registrationDate.month();
      let ageInDecimal = yearsDifference + (monthsDifference / 12);
      ageInDecimal = parseFloat(ageInDecimal.toFixed(1));
      //console.log('registration age', ageInDecimal);

      let ageData = ageInFloat - ageInDecimal;
      //console.log('ageData', ageData);
    })();
  }, []);

  useEffect(() => {
    fetchFacpResult();


  }, []);

  let currentAge = 0;

  const fetchStudentById = async () => {
    console.log('if call')
    if (location.hasOwnProperty('pathname') && location.pathname.split('/').length >= 3) {
      student.id = location.pathname.split('/')[2];
    }
    console.log('id', student.id)
    let result = await inventoryApi.fetchStudentById(student.id);
    console.log('result student:', result);
    let age = null;
    const dob = moment(result.dob);
    const today = moment();

    const yearsDiff = today.year() - dob.year();
    dob.add(yearsDiff, 'years');
    const monthsDiff = today.month() - dob.month();
    let ageInFloat = yearsDiff + (monthsDiff / 12);
    ageInFloat = parseFloat(ageInFloat.toFixed(1));
    //console.log(' dob age', ageInFloat);
    setAge(ageInFloat);


    let registrationAge = null;
    const registrationDate = moment(result.childregistrationdate);
    let dobDate = moment(result.dob);

    const yearsDifference = registrationDate.diff(dobDate, 'years');
    console.log('yearsDifference', yearsDifference)
    dobDate.add(yearsDifference, 'years');
    const monthsDifference = registrationDate.diff(dobDate, 'months');
    console.log('monthsDifference', monthsDifference)
    let ageInDecimal = yearsDifference + (monthsDifference / 12);
    console.log('ageinDecimal', ageInDecimal);
    ageInDecimal = parseFloat(ageInDecimal.toFixed(1));
    console.log('Age difference in decimal:', ageInDecimal);
    setRegistrationAge(ageInDecimal);
    setStudent(result);


  };


  const editStudent = () => {
    navigate(`/students/${student.id}/e`, { state: student });
  };



  const submitfiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    async function init() {
      const result = await inventoryApi.fetchrequireddocuments(student.id);
      //console.log('required document ', result)
      setrequiredDocuments(result);
    }
    init();


  };

  useEffect(() => {

  }, [phsioQuestionMarks]);




  useEffect(() => {
    async function init() {
      const result = await inventoryApi.fetchrequireddocuments(student.id);
      //console.log('required document ', result)
      setrequiredDocuments(result);
    }
    init();

  }, []);

  const editPersonalInfo = () => {
    async function initStudent() {
      let result = await inventoryApi.fetchStudentPersonalInfo(student);
      //////console.log('call edit personal button for fetch result', result)
      if (result.id) {
        navigate(`/students/personalInfo/${result.id}`, { state: result });
      }
      else {
        navigate(`/students/${student.id}/personalInfo`, { state: student.id });
      }
    }
    initStudent();
  };


  const parentEditInfo = () => {
    async function initStudent() {
      let result = await inventoryApi.fetchStudentParent(student);
      student.fathername = result.fathername;
      //////console.log('call edi t button for fetch result', result)
      //////console.log('student>>>>>>>', student)
      if (result.id) {
        navigate(`/students/parent/${result.id}`, { state: result });
      }
      else {
        navigate(`/students/${student.id}/parent`, { state: student });
      }
    }
    initStudent();
  };

  const editAssesment = () => {
    async function initStudent() {
      let result = await inventoryApi.fetchStudentAssessment(student);
      console.log('call edit button for fetch result', result)
      if (result.id) {
        navigate(`/students/assessmentEdit/${result.id}`, { state: result });
      }
      else {
        console.log('student', student);
        navigate(`/students/${student.id}/assessmentEdit`, { state: student.id });
      }
    }
    initStudent();
  }

  const handlePhysiotherepy = () => {
    async function initStudent() {
      let result = await inventoryApi.fetchStudentPhysioAssessment(student);
      //console.log('physioAssessment', result)
      if (result && result.id) {
        navigate(`/student/physioassessment/${result.id}`, { state: result })

      }
      else {
        navigate(`/student/${student.id}/physioassessment`, { state: student })
      }
    }
    initStudent();
  }

  const editDST = () => {
    async function initStudent() {
      let result = await inventoryApi.fetchDSTWithStudentId(student.id);
      // //////console.log('result $$$$$$$$$$$$$$$$$', result)  
      if (result?.id) {
        navigate(`/students/DST/${result.id}`, { state: result });
      }
      else {
        navigate(`/students/${student.id}/DST`, { state: student });
      }
    }
    initStudent();
  }


  let currentStudentAge = 0;
  /**
   * RMKM new Implementation
   * @addedBy @ali-hussain
   * date : 12 September 2025
   * Enhanced the method according to assessment number logic
   *  */
  const studentQuestionsScoring = async (e, btnName) => {
    if (btnName === 'FACP' || btnName === 'PHYSIO') {
      setcurrentAssessmentType(btnName)
      setShowModal(true);
      async function init() {
        let result = await inventoryApi.fetchFACPAssessmentInfo(student.id);
        console.log('result facp', result)
        setFacpAssessment(result);

      }
      init();
    } else if (btnName === 'BEHAVE') {

      let result = await inventoryApi.fetchStudentBehaveById(student.id)
      console.log('result', result)
      if (result.id) {
        console.log('if call')
        navigate(`/studentbehaviour/${result.id}`, { state: result });
      } else {
        console.log('else call')
        navigate(`/studentbehaviour`, { state: student.id });
      }


    } else {
      setScoringName(btnName);
      console.log('registrationAge', registrationAge);
      let result = await inventoryApi.fetchUniqueAssessmentNumber(student.id, btnName);
      console.log('assessmentNumber', result);
      setAssessmentNumberList(result || []);
      setShowAssessmentSelection(true);
    }
  }
  const openScoring = async (assessmentNumber) => {

    if (scoringName === 'DST') {
      navigate(`/students/assessment/DST/${student.id}/${assessmentNumber}`, { state: { ...student, qstype: scoringName, Currentage: student.childregistrationage, assessmentNumber } })
    } else if (scoringName === 'VSMS') {
      navigate(`/students/assessment/VSMS/${student.id}/${assessmentNumber}`, { state: { ...student, qstype: scoringName, Currentage: student.childregistrationage, assessmentNumber } })
    } else if (scoringName === 'GDT') {
      navigate(`/students/assessment/GDT/${student.id}/${assessmentNumber}`, { state: { ...student, qstype: scoringName, assessmentNumber } })
    }

  }
  const handleNextButton = () => {

    if (currentAssessmentType === 'FACP') {
      navigate(`/students/${student.id}/FACP/${assessmentId}`, { state: { ...student, qstype: 'FACP' } })

    } else if (currentAssessmentType === 'PHYSIO') {
      navigate(`/students/${student.id}/PHYSIO/${assessmentId}`, { state: { ...student, qstype: 'PHYSIO' } })
    }


  }
  const handleAssessmentSelection = (item) => {
    const { assessmentname, period, assessmentid } = item;
    setAssessmentId(assessmentid)
  }
  const pdfRow = () => {

    setshowDetails(true)
    ////console.log('if pdf row call')
    const pdfTable = document.getElementById("divToPrint");
    ////console.log("pdf table", pdfTable);
    var html = htmlToPdfmake(pdfTable.innerHTML, {
      tableAutoSize: true,
    });
    ////console.log('html', html)
    const documentDefinition = {
      content: html, defaultStyle: {
        font: 'arialunicodems1'
      }
    };
    pdfMake.fonts = {
      arialunicodems1: {
        normal: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
        bold: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
      },

      // download default Roboto font from cdnjs.com
      Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
      }
    }
    ////console.log(pdfMake.vfs)
    pdfMake.createPdf(documentDefinition).open();
  };


  const handleNextPdf = () => {
    setNextButtonTrue(true);
    fetchFacpResult(nextButtontrue)
  }


  const showFacpModal = async () => {
    setgenerateFacpReport(true)
    setfacpModalShow(true);
    let result = await inventoryApi.fetchFACPAssessmentInfo(student.id);
    console.log('result $$$$$$$$$$$$$$$$$', result)
    if (result) {
      setFacpAssessmentPdf(result);
    }
  }




  const handlePhysioAssessmentSelection = async (item) => {
    setphysioAssessmentId(item.assessmentid);
  }


  const handlePhysioNext = async () => {
    let assessmentName = 'PHYSIO';
    //console.log(physioAssessmentId)
    let result = await inventoryApi.getAssessmentQuestions(assessmentName, student.id, physioAssessmentId);
    //console.log('questions => ', result);
    let marks = await inventoryApi.getMarks(student.id, result[0].assessmentid);
    //console.log('questions marks => ', marks);
    result.forEach((question) => {
      marks?.forEach((mark) => {
        if (mark.questionid === question.id) {
          question.marks = mark.marks;
        }
      });
    });
    setphsioQuestionMarks(result);

    //console.log(phsioQuestionMarks, phsioQuestionMarks);
  }

  const fetchFacpResult = async (nextButtontrue) => {
    const pdfTable = document.getElementById("facpresult");
    ////console.log("pdf table", pdfTable);
    var html = htmlToPdfmake(pdfTable.innerHTML, {
      tableAutoSize: true,
    });
    ////console.log('html', html)
    const documentDefinition = {
      content: html, defaultStyle: {
        font: 'arialunicodems1'
      }
    };
    pdfMake.fonts = {
      arialunicodems1: {
        normal: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
        bold: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
      },
      Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
      }
    }
    if (nextButtontrue === false || nextButtontrue === true) {
      pdfMake.createPdf(documentDefinition).open();
      setfacpModalShow(false)
      setgenerateFacpReport(false)
    }
  };

  const values = [

    "Pre-Primary",
    "Primary 1st",
    "Primary 2nd",
    "Secondary",
    "Pre-Vocational 1st",
    "Pre-Vocational 2nd",
    "Care Group"
  ];


  const handleSelectFACPDataPdf = async (item, value) => {
    let pdfinfo = pdfInfoFacp;
    pdfinfo.assessment = item.assessmentid
    pdfinfo.assessmentperiod = item.period
    setpdfInfoFacp(pdfinfo);
    const result = await inventoryApi.fetchFacpResult(student.id, pdfInfoFacp.assessment);
    //console.log('result ===== facp result', result)
    setAssessmentResult(result);
    ////console.log(pdfInfoFacp)
  };

  const handleAccesscategory = async (value) => {
    console.log('value category', value)
    let data = pdfInfoFacp;
    console.log('pdf info', pdfInfoFacp)
    console.log('data ', data)
    data.category = value;
    setpdfInfoFacp(data)
    console.log('final assessment data', pdfInfoFacp)
    const result = await inventoryApi.fetchFacpResult(student.id, pdfInfoFacp.assessment);
    //console.log('result ===== facp result', result)
    const categoryArray = Object.keys(result).map((categoryName) => ({
      name: categoryName,
      items: result[categoryName],
    }));
    //console.log('categoryArray', categoryArray)
    if (Array.isArray(value) && value.length > 0) {
      //console.log('is array call')
      setDataFacp(categoryArray);
    } else {
      const filteredItems = categoryArray.filter((item) => item.items.category === value);
      //console.log('filteredItems', filteredItems)
      setDataFacp(filteredItems);
      //console.log('data', dataFacp)
    }
  }



  const handleCloseWorkModel = () => {
    ShowselectYear(false);
  }

  const [selectedYear, setSelectedYear] = useState("");


  const selectWorkYear = (event) => {
    const selectedDate = new Date(event.target.value);
    const month = selectedDate.getMonth() + 1; // Months are zero-based, so add 1
    const day = 1; // Set the day to 1

    const formattedDate = new Date(selectedDate.getFullYear(), month - 1, day)
      .toLocaleDateString("en-CA", { year: "numeric", month: "2-digit", day: "2-digit" });

    console.log(formattedDate); // Outputs the selected year with month and day set to 01

    setSelectedYear(formattedDate);

  }



  const studentWorkBehaviour = async () => {
    let result = await inventoryApi.fetchStuWorkBehaveById(student);
    console.log('result', result);
    if (result.id) {
      navigate(`/students/workerbehaviours/${result.id}`, { state: { id: result.id, workbehavedate: selectedYear, studentid: result.studentid } });
    } else {
      console.log('else call');
      navigate(`/students/${student.id}/workerbehaviours`, { state: { id: student.id, workbehavedate: selectedYear } });
    }
  };


  const handleWorkBehaviourPdf = () => {
    const pdfTable = document.getElementById("workBheaviourPdf");
    //console.log("pdf table", pdfTable);
    var html = htmlToPdfmake(pdfTable.innerHTML, {
      tableAutoSize: true,
    });
    console.log('html', html)
    const documentDefinition = {
      content: html, defaultStyle: {
        font: 'arialunicodems1'
      }
    };
    //console.log('documentDefinition', documentDefinition)
    //pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
      arialunicodems1: {
        normal: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
        bold: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
      },


      // download default Roboto font from cdnjs.com
      Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
      }
    }
    //console.log(pdfMake.vfs)
    pdfMake.createPdf(documentDefinition).open();
  }


  const handleBehaviourtabkey = async (key) => {
    console.log('key', key)
    if (key === 'analysis') {
      console.log('student.id', student.id)
      let result = await inventoryApi.fetchJobAnaStudentById(student.id);
      console.log('result ====> ', result)
      if (result.id) {
        result.studentid = student.id
        console.log('IF CALL')
        navigate(`/analysis/${result.id}`, { state: result });
      } else {
        console.log('else')
        navigate(`/analysis`, { state: student.id });
      }

    } else if (key === 'vocational') {
      console.log('student.id', student.id)
      let result = await inventoryApi.fetchVocStudentByid(student.id);
      console.log('result ====> ', result)
      if (result.id) {
        console.log('IF CALL')
        navigate(`/vocationalprofile/${result.id}`, { state: result.id });
      } else {
        console.log('else')
        navigate(`/vocationalprofile/e`, { state: student.id });
      }

    }
    else {
      console.log('student.id', student.id);
      let result = await inventoryApi.fetchHomeBasedCbrById(student.id);
      console.log('result ====> ', result)
      if (result.id) {
        console.log('IF CALL')

        navigate(`/homebasedcbr/${result.id}/e`, { state: result });
      } else {
        console.log('else')
        navigate(`/homebasedcbr/e`, { state: { studentid: student.id } });
      }
    }

  }
  useEffect(() => {
    handleStudentBehaviourPdf()
  }, []);
  const [studentbehavedata, setstudentbehavedata] = useState({});

  const handleStudentBehaviourPdf = async () => {
    let result = await inventoryApi.fetchStudentBehaveById(student.id)
    console.log('result', result);
    setstudentbehavedata(result)
    setStudentModalShow(true)

  }


  const pdfShow = () => {
    const pdfTable = document.getElementById("divToPrintStdBehave");
    console.log("pdf table india", pdfTable);
    var html = htmlToPdfmake(pdfTable.innerHTML, {
      tableAutoSize: true,
    });
    console.log('html', html)
    const documentDefinition = {
      content: html, defaultStyle: {
        font: 'arialunicodems1'
      }
    };
    //console.log('documentDefinition', documentDefinition)
    //pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
      arialunicodems1: {
        normal: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
        bold: `${constants.SERVER_BASE_URL}/font/ArialUnicodeMS.ttf`,
      },


      // download default Roboto font from cdnjs.com
      Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
      }
    }
    //console.log(pdfMake.vfs)

    pdfMake.createPdf(documentDefinition).open();


  }


  return (
    <div>
      {student && (
        <Container>
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}

              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="lead"
            />
          )}

          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{currentAssessmentType} Assessment </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex flex-column ">


                <div className="col-auto pb-2" style={{}}>


                  {!facpAssessment || facpAssessment.length === 0 ?
                    'No assessment available' : 'Select ' + currentAssessmentType + ' Assessment'

                  };


                </div>
                {facpAssessment?.map((item) => {
                  if (item.assessmentcategory === currentAssessmentType) {

                    const endDate = new Date(item.enddate);
                    const startDate = new Date(item.startdate);

                    const formatDate = (date) => {
                      const options = { day: 'numeric', month: 'long', year: 'numeric' };
                      return date.toLocaleDateString('en-US', options);
                    }

                    const formattedEndDate = formatDate(endDate);
                    const formattedStartDate = formatDate(startDate);

                    //console.log(formattedStartDate); // "17 April, 2023"
                    //console.log(formattedStartDate); // "17 April, 2023"

                    return (
                      <div key={item.id} className="row no-gutters">
                        <div className="col-auto mb-2" style={{ marginLeft: '30px' }}>
                          <input type="radio" name='assessment' onChange={() => handleAssessmentSelection(item)}></input>
                        </div>
                        <div className="col" style={{ marginLeft: '10px', fontSize: '12px' }}>
                          <b>{item.assessmentname} - {item.period}</b>
                        </div>
                        <div className="col" style={{ marginLeft: '10px', fontSize: '12px' }}>
                          <b>{formattedStartDate} -  {formattedEndDate} </b>

                        </div>
                      </div>
                    );
                  }
                })}

              </div>
            </Modal.Body>
            <Modal.Footer>
              {facpAssessment && facpAssessment.length > 0 ?
                <Button variant="primary" onClick={() => handleNextButton()}>
                  Next
                </Button> : ''}
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Row className="view-form mx-2">

            <Col lg={9} style={{ border: '1px solid #ccc' }}>
              <Row className="view-form-header align-items-center">
                <Col lg={3}>
                  {student.name ? student.name : 'Student'}
                </Col>

                <Col lg={9} className="d-flex justify-content-end">
                  <Button
                    className="btn-sm mx-2"
                    variant="primary"
                    onClick={() => { editStudent() }}
                  >
                    Edit Student <span className="numberCircle">A</span>
                  </Button>

                  <Button
                    className="btn-sm mx-2"
                    variant="primary"
                    onClick={() => { parentEditInfo() }}
                  >
                    Parent Info <span className="numberCircle">B</span>
                  </Button>
                  <Button
                    className="btn-sm mx-2"
                    variant="primary"
                    onClick={() => { editPersonalInfo() }}
                  >
                    Personal Info <span className="numberCircle">C</span>
                  </Button>



                  <Dropdown>
                    <Dropdown.Toggle variant="primary"  >
                      Part D <span className="numberCircle">D</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => { editAssesment() }}>Student Assessment</Dropdown.Item>
                      <Dropdown.Item onClick={handlePhysiotherepy}>Physiotherapy</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>


                  <Dropdown>


                    <Dropdown.Toggle variant="primary" className="mx-2" >
                      Part E <span className="numberCircle">E</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={(e) => studentQuestionsScoring(e, 'DST')}>DST Scoring</Dropdown.Item>
                      <Dropdown.Item onClick={(e) => studentQuestionsScoring(e, 'VSMS')}>VSMS Scoring</Dropdown.Item>
                      <Dropdown.Item onClick={(e) => studentQuestionsScoring(e, 'GDT')}>GDT Scoring</Dropdown.Item>

                    </Dropdown.Menu>
                  </Dropdown>

                </Col>
              </Row>

              <Row>
                <Col lg={6}>
                  <label>Registration Number</label>
                  <span>{student.regnumber}</span>
                </Col>
                <Col lg={6}>
                  <label>Religion</label>
                  <span>{student.religion}</span>
                </Col>
                <Col lg={6}>
                  <label>Name</label>
                  <span>{student.name}</span>
                </Col>
                <Col lg={6}>
                  <label>Father Name</label>
                  <span>{student.fathername}</span>
                </Col>
                <Col lg={6}>
                  <label>Registration Date</label>
                  <span>{student.childregistrationdate ? moment(student.childregistrationdate).format('DD-MM-YYYY') : ''}</span>
                </Col>

                <Col lg={6}>
                  <label>Age at Enrollment</label>
                  {/* <span>{isNaN(registrationAge) ? '' : registrationAge}</span> */}
                  <span>{student.childregistrationage}</span>

                </Col>


                <Col lg={6}>
                  <label>DOB</label>
                  <span>{moment(student.dob).format('DD-MM-YYYY')}</span>
                </Col>
                { /**
                 * RMKM Phase 2 Changes
                 * added by @ali 
                 * date : 9 April 2025
                 * Added a new field child_age to get child's current age
                 *  */
                }
                <Col lg={6}>
                  <label>Current Age</label>
                  <span>{student?.child_age}</span>
                </Col>

                {/* Commant code Aamir khan 12-12-2023 */}
                
                {/* <Col lg={6}>
                  <label>Current Age</label>
                  <span>{isNaN(age) ? '' : age}</span>
                </Col> */}

                <Col lg={6}>
                  <label>Phone</label>
                  <span>{student.phone}</span>
                </Col>

                <Col lg={6}>
                  <label>Problem</label>
                  <span>{student.problem}</span>
                </Col>
                <Col lg={6}>
                  <label>Aadhar No.</label>
                  <span>{student.adharcard}</span>
                </Col>

                <Col lg={6}>
                  <label>Gender</label>
                  <span>{student.gender}</span>
                </Col>
                <Col lg={6}>
                  <label>REFERRED BY</label>
                  <span>{student.refferby}</span>
                </Col>
                <Col lg={6}>
                  <label>Service Area</label>
                  <span>{student.servicearea}</span>
                </Col>
                <Col lg={6}>
                  <label>Service Category</label>
                  <span>{student.servicecategoryname}</span>
                </Col>

                <Col lg={6}>
                  <label>Staff Name</label>
                  <span >
                    {student.refertostaff && student.refertostaff instanceof Array && student.refertostaff.map((item, index) => {

                      return <Badge bg="warning" style={{ display: 'inline-block', marginBottom: '2px', 'marginRight': '5px', color: '#000' }}>{item.label}</Badge>
                    })}


                  </span>
                </Col>
                <Col lg={6}>
                  <label>Mother Tongue</label>
                  <span>{student.mothertongue}</span>
                </Col>

                <Col lg={6}>
                  <label>Status</label>
                  <span>{student.status}</span>
                </Col>
                {
                  /**
                   * RMKM Phase 2 Changes
                   * added by @ali 
                   * date : 9 April 2025
                   * Added some new fields inactive_reason & migration_period as per clint requirement
                   *  */
                }
                {student.status === 'Inactive' && <Col lg={6}>
                  <label>Inactive Reason</label>
                  <span>{student.inactive_reason}</span>
                </Col>}
                {student.inactive_reason === 'Migrated' && <Col lg={6}>
                  <label>Migration Period</label>
                  <span>{student.migration_period}</span>
                </Col>}

                {student.status === 'Dropout' ?
                  <Col lg={6}>
                    <label>Dropout Reason</label>
                    <span>{student.dropoutreason}</span>
                  </Col>
                  : ''}
                {student.status === 'Dropout' ?
                  <Col lg={6}>
                    <label>Dropout Date</label>
                    <span>{moment(student.dropoutdate).format('DD-MM-YYYY')}</span>
                  </Col> : ''}
                {
                  /**
                   * RMKM new Implementation
                   * @addedBy @ali-hussain
                   * date : 12 September 2025
                   * Added new field last achievement date  
                   *  */
                }
                <Col lg={6}>
                  <label>Last Achievement Date</label>
                  <span>{moment(student.last_achievement_date).format('DD-MM-YYYY')}</span>
                </Col>
                {
                  /**
                   * RMKM Phase 2 Changes
                   * added by @ali 
                   * date : 9 April 2025
                   * Added some new fields last_achievement & employee_type as per clint requirement
                   *  */
                }
                <Col lg={6}>
                  <label>Last Achievement</label>
                  <span>{student.last_achievement}</span>
                </Col>

                {student.last_achievement === 'Employed' && <Col lg={6}>
                  <label>Employee Type</label>
                  <span>{student.employee_type}</span>
                </Col>}

                <Col lg={6}>
                  <label>Remark</label>
                  <span>{student.remark}</span>
                </Col>
              </Row>
            </Col>

            <Col lg={3} >

              <div className="view-form-header text-center p-2">
                Score Card
              </div>


              <Button
                className=" my-2 btn btn-sm btn-block"

                variant="outline-primary"
                onClick={(e) => studentQuestionsScoring(e, 'DST')
                }
              >
                <b>DST Scoring</b>
              </Button>

              <Button
                className=" my-2 btn btn-sm btn-block"
                variant="outline-primary"
                onClick={(e) => studentQuestionsScoring(e, 'VSMS')
                }
              >
                <b>VSMS Scoring</b>
              </Button>
              <Button
                className=" my-2 btn btn-sm btn-block"
                variant="outline-primary"
                onClick={(e) => studentQuestionsScoring(e, 'GDT')
                }
              >
                <b>GDT Scoring</b>
              </Button>

              <Button
                className=" my-2 btn btn-sm btn-block"
                variant="outline-primary"
                onClick={(e) => studentQuestionsScoring(e, 'FACP')
                }
              >
                <b>FACP Scoring</b>
              </Button>



              <Button
                className=" my-2 btn btn-sm btn-block"
                variant="outline-primary"
                onClick={(e) => studentQuestionsScoring(e, 'PHYSIO')
                }
              >
                <b>PHYSIO Scoring</b>
              </Button>


              {/* <Button
                className=" my-2 btn btn-sm btn-block"
                variant="outline-primary"
                onClick={() => setShowSelectYear(true)}
              >
                <b>Work Behaviour Scoring</b>
              </Button> */}


              <Button
                className=" my-2 btn btn-sm btn-block"
                variant="outline-primary"
                onClick={(e) => studentQuestionsScoring(e, 'BEHAVE')
                }
              >
                <b>VAPS Scoring </b>
              </Button>

              <hr />

              <button
                className=" my-2 btn-sm btn-block text-left blue"

                onClick={() => { pdfRow() }}
              >
                <i class="fa-solid fa-download ml-2 mr-4" style={{ color: '#ffffff' }}></i>
                <b>Student Case History</b>

              </button>

              <button
                className=" my-2 btn-sm btn-block blue"
                variant="light" onClick={(e) => showFacpModal(e, 'GDT')
                }
              >
                <i class="fa-solid fa-download ml-2 mr-4" style={{ color: '#ffffff' }}></i> <b>FACP Report</b>
              </button>
              {/* <button
                className=" my-2 btn-sm btn-block blue"
                variant="light" onClick={(e) => handlePhysioModal()
                }
              >
                <i class="fa-solid fa-download ml-2 mr-4" style={{ color: '#ffffff' }}></i> <b>PHYSIO Report</b>
              </button> */}

              {/* <button
                className=" my-2 btn-sm btn-block blue"
                variant="light" onClick={(e) => handleWorkBehaviourPdf()
                }
              >
                <i class="fa-solid fa-download ml-2 mr-4" style={{ color: '#ffffff' }}></i> <b>Work Behaviour Report</b>
              </button> */}

              {/* <button
                className=" my-2 btn-sm btn-block blue"
                variant="light" onClick={(e) => pdfShow()
                }
              >
                <i class="fa-solid fa-download ml-2 mr-4" style={{ color: '#ffffff' }}></i> <b>Student Behaviour Report</b>
              </button> */}


            </Col>
          </Row>

          {/* <Row>
            <Container>
              <Col lg={12} className="section-header-analysis my-3">
                Student Behavioral Analysis Assessment
              </Col>
              <div className="d-flex justify-content-between align-items-center assesment_button px-2">
                <Col lg={4} md={6} sm={12} className="d-flex justify-content-between ass_Analysis">
                  <div
                    className="std_assesment fc-event"
                    eventKey="analysis"
                    onClick={() => handleBehaviourtabkey("analysis")}
                  >
                    <span className="mx-2">
                      <i className="fa-solid fa-magnifying-glass-chart"></i>
                    </span>
                    <span className="fs-6 fw-bold">VAPS Job Analysis (PHASE 1)</span>
                  </div>
                </Col>

                <Col lg={4} md={6} sm={12} className="d-flex justify-content-between ass_Analysis">
                  <div
                    className="std_assesment fc-event"
                    eventKey="vocational"
                    onClick={() => handleBehaviourtabkey("vocational")}
                  >
                    <span className="mx-2">
                      <i className="fa-solid fa-magnifying-glass-chart"></i>
                    </span>
                    <span className="fs-6 fw-bold">Vocational Profile (PHASE 2)</span>
                  </div>
                </Col>

                <Col lg={4} md={6} sm={12} className="d-flex justify-content-between ass_Analysis">
                  <div
                    className="std_assesment fc-event"
                    eventKey="home"
                    onClick={() => handleBehaviourtabkey("home")}
                  >
                    <span className="mx-2">
                      <i className="fa-solid fa-magnifying-glass-chart"></i>
                    </span>
                    <span className="fs-6 fw-bold">Home Based CBR (PHASE 3)</span>
                  </div>
                </Col>
              </div>
            </Container>

          </Row> */}



          {requiredDocuments.documents &&
            <Alert variant='danger' className="my-3 mx-2">
              Please Upload Required Documents: <b>{requiredDocuments.documents.replaceAll(',', ', ')}</b>
            </Alert>
          }
          <Card bg="light" text="light" className="mb-2 mt-4">
            <Card.Header className="d-flex justify-content-between">
              <Tabs defaultActiveKey="files" id="uncontrolled-tab-example">
                <Tab eventKey="files" title="Files"></Tab>
              </Tabs>
              <Button
                className="float-right btn-sm"
                onClick={() => setModalShowFile(true)}
              >
                Upload File
              </Button>
              {modalShowTaskfile && (
                <FilesCreate
                  show={modalShowTaskfile}
                  onHide={() => setModalShowFile(false)}
                  parent={student}
                  submitfiles={submitfiles}
                  objectName="student"
                />
              )}
            </Card.Header>
            <Card.Body>
              {/* <RelatedListFiles parent={student} files={files} /> */}
              <RelatedListFiles refreshFileList={refreshFileList} parent={student} />
            </Card.Body>
          </Card>
          <div className="App container mt-5" style={{ display: 'none' }}>
            <div id="divToPrint">
              <html>
                <head>
                  <meta charset="UTF-8" />
                </head>
                <body>
                  <CaseHistory data={student} />
                </body>
              </html>
            </div>
          </div>
          <div className="App container mt-5" style={{ display: 'none' }}>

            <Modal show={facpModalShow} onHide={() => setShowModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>FACP Assessment </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="d-flex flex-column ">
                  <Row>
                    <Col><div className="col-auto pb-2" style={{}}>
                      <b> {!facpAssessmentpdf || facpAssessmentpdf.length === 0 ?
                        'No assessment available' : 'Select FACP Assessment'}</b>
                    </div>
                    </Col>
                    <Col>
                      <b>Select FACP Category</b>
                    </Col>
                  </Row>

                  <Row>
                    <Col className="mt-3">
                      {facpAssessmentpdf?.map((item) => {
                        const endDate = new Date(item.enddate);
                        const startDate = new Date(item.startdate);

                        const formatDate = (date) => {
                          const options = { day: 'numeric', month: 'long', year: 'numeric' };
                          return date.toLocaleDateString('en-US', options);
                        }

                        const formattedEndDate = formatDate(endDate);
                        const formattedStartDate = formatDate(startDate);

                        //console.log(formattedStartDate); // "17 April, 2023"
                        //console.log(formattedEndDate); // "17 April, 2023"

                        return (
                          <div key={item.id} className="row no-gutters">
                            <div className="col-auto mb-2" style={{ marginLeft: '30px' }}>
                              <input type="radio" name='assessment' onChange={() => handleSelectFACPDataPdf(item)}></input>
                            </div>
                            <div className="col" style={{ marginLeft: '10px', fontSize: '12px' }}>
                              <b>{item.assessmentname} - {item.period}</b>
                            </div>
                            {/* <div className="col" style={{ marginLeft: '10px', fontSize: '12px' }}>
                              <b>{formattedStartDate} - {formattedEndDate}</b>
                            </div> */}
                          </div>
                        );
                      })}
                    </Col>

                    <Col>


                      <ListGroup className="mt-3">
                        <ListGroup.Item key="all">
                          <Form.Check
                            inline
                            name="selectAllCategoryName"
                            value={values}
                            type="radio"
                            id={`inline-radio-all`}
                            onChange={(e) => handleAccesscategory(values)}
                          />

                          Select All
                        </ListGroup.Item>
                        {values.map((value, index) => {
                          const isCategoryEnabled = assessmentResult && assessmentResult.some(obj => obj.category === value);
                          return (
                            <ListGroup.Item key={index} className={isCategoryEnabled ? "" : "disabled"}>
                              <Form.Check
                                inline
                                name="categoryname"
                                value={value}
                                type="radio"
                                id={`inline-radio-${index}`}
                                onChange={(e) => handleAccesscategory(value)}
                                disabled={!isCategoryEnabled}
                              />
                              {value}
                            </ListGroup.Item>
                          );
                        })}


                      </ListGroup>
                    </Col>
                  </Row>

                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => handleNextPdf()}>
                  Next
                </Button>
                <Button variant="secondary" onClick={() => setfacpModalShow(false)}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>

          </div>


          {/*  PHSYO Modal  */}



          <Modal show={phsyioShowModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title> PHYSIO Assessment </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex flex-column ">


                <div className="col-auto pb-2" style={{}}>


                  {!physioResult || physioResult.length === 0 ?
                    'No assessment available' : 'Select PHYSIO Assessment'

                  };
                </div>
                {physioResult.map((item) => {
                  const endDate = new Date(item.enddate);
                  const startDate = new Date(item.startdate);

                  const formatDate = (date) => {
                    const options = { day: 'numeric', month: 'long', year: 'numeric' };
                    return date.toLocaleDateString('en-US', options);
                  }

                  const formattedEndDate = formatDate(endDate);
                  const formattedStartDate = formatDate(startDate);

                  return (
                    <div key={item.id} className="row no-gutters">
                      <div className="col-auto mb-2" style={{ marginLeft: '30px' }}>
                        <input type="radio" name='assessment' onChange={() => handlePhysioAssessmentSelection(item)}></input>
                      </div>
                      <div className="col" style={{ marginLeft: '10px', fontSize: '12px' }}>
                        <b>{item.assessmentname} - {item.period} </b>
                      </div>
                      <div className="col" style={{ marginLeft: '10px', fontSize: '12px' }}>
                        <b>{formattedStartDate} - {formattedEndDate} </b>
                      </div>
                    </div>
                  );
                })}

              </div>
            </Modal.Body>
            <Modal.Footer>
              {physioResult && physioResult.length > 0 ?
                <Button variant="primary" onClick={() => handlePhysioNext()}>
                  Next
                </Button> : ''}
              <Button variant="secondary" onClick={() => setphsyioShowModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <div id="facpresult">
            {generateFacpReport === true && (
              <FacpSectionResult data={student} reportInfo={dataFacp} />
            )}
          </div>


          {/* <div id="phsyioResult">
            {phsyioShowModal === true && (
              <PhysioSectionReport data={student} phsioQuestionMarks={phsioQuestionMarks} />
            )
            }
          </div> */}
          
          {studentmodalShow && (
            <div className="App container mt-5" style={{ display: 'none' }}>
              <div id="divToPrintStdBehave">
                <StudentBehaviourPdf data={studentbehavedata} />
              </div>
            </div>
          )}

        </Container>
      )}

      <Modal show={ShowselectYear} onHide={() => setShowSelectYear(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Select Work Behaviour Year</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column ">
            <div className="col-auto pb-2" style={{}}>
            </div>
            <div className="row no-gutters">
              <div className="col-auto mb-2" style={{ marginLeft: '30%', width: "50%" }}>
                <Form>

                  <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Select Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="workbehavedate"
                      value={selectedYear}
                      onChange={selectWorkYear}
                    /></Form.Group>
                </Form>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>

          <Button variant="primary" onClick={() => studentWorkBehaviour()}>
            Next
          </Button>
          <Button variant="secondary" onClick={() => setShowSelectYear(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {
        /**
         * RMKM new Implementation
         * @addedBy @ali-hussain
         * date : 12 September 2025
         * Added Modal for assessment number selection
         *  */
      }
      <Modal show={showAssessmentSelection} onHide={() => setShowAssessmentSelection(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Assessment Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column ">
            <div className="col-auto pb-2" style={{}}>
              {!assessmentNumberList || assessmentNumberList.length === 0 ?
                'No assessment available' : 'Select Assessment Number'
              };
            </div>
            {assessmentNumberList.map((item, index) => {
              return (
                <div key={index} className="row no-gutters">
                  <div className="col-auto mb-2" style={{ marginLeft: '30px' }}>
                    <input type="radio" name='assessment' value={item?.assessment_no} onChange={(e) => setAssessmentNumber(e.target.value)}></input>
                  </div>
                  <div className="col" style={{ marginLeft: '10px', fontSize: '12px' }}>
                    <b>{item?.assessment_no}</b>
                  </div>
                </div>
              );
            })}

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" disabled={!assessmentNumber} onClick={() => openScoring(assessmentNumber)}>
            Open
          </Button>
          <Button variant="secondary" onClick={() => {
            if (assessmentNumberList.length > 0 && assessmentNumberList?.at(-1)?.assessment_no) {
              // openScoring(`${assessmentNumberList?.at(-1)?.assessment_no?.split(' ')[0]} ${assessmentNumberList.length + 1}`);
              openScoring(new Date().toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true  // optional, shows AM/PM format
              }).replaceAll('/', '-'));
            } else {
               openScoring(new Date().toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true  // optional, shows AM/PM format
              }).replaceAll('/', '-'));
            }

          }} >
            Create New
          </Button>

        </Modal.Footer>

      </Modal>

    </div>
  );
};

export default StudentView;